import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from '/webresources-sources/js/util/jquery';

export default class MapFilter extends BaseComponent {
    properties() {
        return {
            regions: {},
            types: {},
        };
    }

    get selectedRegions() {
        const selectedRegions = []

        Object.keys(this.regions).forEach(region => {
            if (this.regions[region] === true) selectedRegions.push(region);
        });

        return selectedRegions.length > 0 ? selectedRegions : ['oberbayern', 'ostbayern', 'franken', 'schwaben'];
    }

    get hasSelectedRegions() {
        const checkedRegions = this.element.querySelectorAll('input[data-filter="region"]:checked');
        return checkedRegions.length > 0;
    }

    get selectedTypes() {
        const selectedTypes = []

        Object.keys(this.types).forEach(type => {
            if (this.types[type] === true) selectedTypes.push(type);
        })

        return selectedTypes.length > 0 ? selectedTypes : ['default', 'hotel', 'story'];
    }

    get hasSelectedTypes() {
        return this.selectedTypes.length !== 3;
    }

    events() {
        return {
            'input[data-filter]': {
                change: (e) => {
                    const input = e.target;
                    const filter = input.dataset.filter;
                    if (filter === 'region') {
                        this.regions[input.name] = input.checked;
                    }
                    if (filter === 'type') {
                        this.types[input.name] = input.checked;
                    }
                    this.requestUpdate();
                },
            },
            '[data-clear-filter]': {
                change: (e) => {
                    const filter = e.target.dataset.clearFilter;
                    const inputs = this.element.querySelectorAll(`[data-filter="${filter}"]`);
                    inputs.forEach((input) => {
                        input.checked = false;
                        if (filter === 'region') {
                            this.regions[input.name] = false;
                        }
                        if (filter === 'type') {
                            this.types[input.name] = false;
                        }
                    });
                    this.requestUpdate();
                },
            },
        };
    }

    update() {
        const clearRegionsInput = this.element.querySelector('[data-clear-filter="region"]');
        clearRegionsInput.checked = !this.hasSelectedRegions;

        const clearTypesInput = this.element.querySelector('[data-clear-filter="type"]');
        clearTypesInput.checked = !this.hasSelectedTypes;

        this.dispatch('filter-change', {
            regions: this.selectedRegions,
            types: this.selectedTypes,
        });

        super.update();
    }
}

defineComponent('map-filter', MapFilter);
